import * as z from 'zod'

import { UpdateMediaAiTrainingDataVars } from '@/common/api/params/mediaAiTrainingData'
import { NameLabelMapping } from '@/common/app/message'
import {
  MediaAiTrainingData,
  RESTRICTIONS_MAX_LENGTH
} from '@/common/model/media/mediaAiTrainingData'

export const commonRulesSchema = z.object({
  siteId: z.number().readonly(),
  restrictions: z
    .string()
    .max(
      RESTRICTIONS_MAX_LENGTH,
      `制約・禁止事項は${RESTRICTIONS_MAX_LENGTH}文字以内で入力してください`
    )
})

export type CommonRulesSchemaType = z.infer<typeof commonRulesSchema>

export const commonRulesNameLabelMapping: NameLabelMapping = {
  restrictions: '制約・禁止事項'
}

export const makeDefaultCommonRulesSchema = (siteId: number): CommonRulesSchemaType => ({
  siteId,
  restrictions: ''
})

export const convertCommonRulesToSchema = (data: MediaAiTrainingData): CommonRulesSchemaType => ({
  siteId: data.site_id,
  restrictions: data.restrictions ?? ''
})

// 保存は部分更新。制約・禁止事項だけを送り、記事HTMLには触れない
export const convertCommonRulesSchemaToVars = (
  data: CommonRulesSchemaType
): UpdateMediaAiTrainingDataVars => ({
  site_id: data.siteId,
  restrictions: data.restrictions
})
